import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import buildOrgBriefChartOption, { ringSliceColor } from "./buildOrgBriefChartOption";
import css from "./OrgBrief.module.scss";

function Chart({ option }) {
  return (
    <ReactECharts
      option={option}
      notMerge
      opts={{ renderer: "svg" }}
      style={{ height: "100%", width: "100%" }}
    />
  );
}

// A ring keeps its total in the hole and its labels in a list beside it, so
// long names such as strategic goals never sit on top of the ring.
function RingChart({ chart, option }) {
  return (
    <div className={css.ringLayout}>
      <div className={css.ring}>
        <Chart option={option} />
        {chart.center && (
          <div className={css.ringCenter}>
            <b>{chart.center.display}</b>
            <span>{chart.center.label}</span>
          </div>
        )}
      </div>
      <ul className={css.ringLegend}>
        {chart.points.map((point, index) => (
          <li key={point.label}>
            <i style={{ background: ringSliceColor(chart, index) }} aria-hidden="true" />
            <span title={point.label}>{point.label}</span>
            <b>{point.display}</b>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function OrgBriefChartCard({ chart }) {
  const option = useMemo(() => buildOrgBriefChartOption(chart), [chart]);
  if (!option) return null;

  return (
    <section className={`${css.card} ${css.chartCard}`} aria-label={chart.title}>
      <div className={css.chartHeader}>
        <h3>{chart.title}</h3>
        <span>{chart.subtitle}</span>
      </div>
      {chart.legend?.length > 0 && (
        <div className={css.legend}>
          {chart.legend.map((item) => (
            <span key={item.label}>
              <i className={item.role === "secondary" ? css.swatchSecondary : css.swatch} aria-hidden="true" />
              {item.label} <b>{item.display}</b>
            </span>
          ))}
        </div>
      )}
      <div className={css.chart}>
        {chart.kind === "ring" ? <RingChart chart={chart} option={option} /> : <Chart option={option} />}
      </div>
    </section>
  );
}
